import { Layout } from 'antd';
import BrandLogo from 'components/BrandLogo';
import styles from './index.module.scss';

const { Header: LayoutHeader } = Layout;

function Header() {
  return (
    <LayoutHeader className={styles.container}>
      <BrandLogo />
    </LayoutHeader>
  );
}

export default Header;
